/**
 * @file   src\Pages\CWOOrderHardware.tsx
 * @brief  Order Hardware page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React,Container,useOutletContext,  useEffect, useState, useLocation } from '../utils/thirdpartyComponents';
import OrderHardware from '../components/OrderHardware';
import { AppContextType } from '../interfaces/generalInterface';
import { pageURLs } from '../utils/pageUrls';

const CWOOrderHardware = () => {
    // Access the context
    const {  updateData } = useOutletContext<AppContextType>();
    const location = useLocation();
    const prevUrl = location.state?.prevUrl || "";
    useEffect(() => {
        handleUpdate()
    }, [])
    
    // Update the data
    const handleUpdate = () => {
        const backurl = (prevUrl == pageURLs.order_list) ? `/${pageURLs.order_history}` : `/${pageURLs.dashboard}`
        updateData({ heading: "Order Hardware", url: backurl, showBackButton: true, showMainMenu: true, activeLink: "hardware" });
    };

    const markStepAsCompleted = (step: string) => {
        setCompletedSteps([...completedSteps, step]);

        // For now in proto only when bank info is complete navigate to locations

    };

    const [completedSteps, setCompletedSteps] = useState<string[]>([]);


    return (

        <div className='hardware-listing-container cwo-order-hardware'>
            <Container>
                <div className="hardware-list-wrap">
                <OrderHardware onComplete={() => markStepAsCompleted('hardware')} />
                </div>
            </Container >
        </div >
    )
}

export default CWOOrderHardware;
